export var ApplePayEventListenerEnumsObj = {
    PAYAIR_APPLE_PAY_SDK_LISTENER: "PAYAIR_APPLE_PAY_SDK_LISTENER",
};
